// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseApiServiceFactory instead of class inheritance

import { createBaseApiService, type IBaseApiService } from "@Front/Api/BaseApiServiceFactory";
import type { AuthInstance } from "./helpers/authInstanceHelpers";
import { createAuthInstance } from "./helpers/authInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseApiService, AuthInstance>({
	name: "Auth",
	createBase: createBaseApiService,
	createInstance: createAuthInstance,
});

export function getAuthInstance(): AuthInstance {
	return factory.getInstance();
}
